import React, { useEffect } from 'react'
import ModalDetailComponent from '../components/ModalDetailComponent'
import { useDispatch, useSelector } from 'react-redux';
import { openDetail } from '../redux/slice/cameraSlice';
import { getCameraList } from '../redux/action/cameraAction';

const FormDetailCamera = ({ param }) => {
    const dispatch = useDispatch();
    const { dataCamera, isLoading, dataByIdCamera, isOpenDetail } = useSelector( (state) => state.camera );
    // console.log(dataByIdCamera)
  return (
    <ModalDetailComponent
      title="DETAIL DATA KAMERA"
      show={isOpenDetail}
      close={() => dispatch(openDetail({ open: false, type: 'close' }))}
      idForm="detailCamera-form"
    >
        <div className="row" style={{ alignItems: 'center'}}>
            <div className="col-xl-6">
                <table className="table">
                    <thead>
                        {/* <tr>
                            <span> Detail Data Kamera </span>
                         </tr> */}
                    </thead>
                    <tbody>
                        <tr> Nama Kamera : {dataByIdCamera.name} </tr>
                        <tr> Merek Kamera :  {dataByIdCamera.brand} </tr>
                        <tr> Tipe Kamera : {dataByIdCamera.type} </tr>
                        <tr> Lokasi Kamera : {dataByIdCamera.location} </tr>
                        <tr> Latitude : {dataByIdCamera.latitude} </tr>
                        <tr> Longitude : {dataByIdCamera.longitude} </tr>
                        <tr> Altitude : {dataByIdCamera.alt} </tr>
                        <tr> URL : {dataByIdCamera.url} </tr>
                    </tbody>
                </table>
            </div>
            <div className="col-xl-6">
                <tbody>
                    <tr> Alamat Ip : {dataByIdCamera.ip} </tr>
                    <tr> Pengguna :  {dataByIdCamera.user} </tr>
                    <tr> Kata Sandi : {dataByIdCamera.password} </tr>
                    
                    <tr> Alamat MAC : {dataByIdCamera.mac} </tr>
                    <tr> Nomor Seri : {dataByIdCamera.serialNo} </tr>
                    {/* <tr> Lokasi JPO : {dataByIdCamera.detailSite.siteName} </tr> */}
                </tbody>
            </div>
        </div>
    </ModalDetailComponent>
  )
}

export default FormDetailCamera